import type { CrmChatProviderKey } from '@/api/types/crm/crmLeadFunnels.types'
import {
  getWazzupOutgoingVoiceMaxBytes,
  validateWazzupOutgoingAttachment,
} from './crmIntegrationWazzupOutgoingAttachment'

export const CRM_VOICE_UPLOAD_DISPLAY_NAME = 'Голосовое сообщение'

const VOICE_MAX_BYTES_BY_PROVIDER: Record<CrmChatProviderKey, number> = {
  telegram: 50 * 1024 * 1024,
  vkontakte: 25 * 1024 * 1024,
  max: 256 * 1024 * 1024,
  wazzup: 10 * 1024 * 1024,
}

export const resolveCrmIntegrationVoiceFileExtension = (
  mimeType: string,
): string => {
  const mime = mimeType.toLowerCase()

  if (mime.includes('ogg')) {
    return 'ogg'
  }
  if (mime.includes('webm')) {
    return 'webm'
  }
  if (mime.includes('mp4') || mime.includes('m4a') || mime.includes('aac')) {
    return 'm4a'
  }
  if (mime.includes('wav') || mime.includes('wave')) {
    return 'wav'
  }
  if (mime.includes('mpeg') || mime.includes('mp3')) {
    return 'mp3'
  }

  return 'webm'
}

export const buildCrmIntegrationVoiceFile = (
  blob: Blob,
  mimeType?: string | null,
): File => {
  const resolvedMime = mimeType?.trim() || blob.type || 'audio/webm'
  const extension = resolveCrmIntegrationVoiceFileExtension(resolvedMime)

  return new File([blob], `voice-${Date.now()}.${extension}`, {
    type: resolvedMime,
    lastModified: Date.now(),
  })
}

export const getCrmIntegrationVoiceMaxBytes = (
  provider: CrmChatProviderKey,
  wazzupChannelType?: string | null,
): number => {
  if (provider === 'wazzup') {
    return getWazzupOutgoingVoiceMaxBytes(wazzupChannelType)
  }
  return VOICE_MAX_BYTES_BY_PROVIDER[provider]
}

export const isCrmIntegrationVoiceFileWithinSizeLimit = (
  file: File,
  provider: CrmChatProviderKey,
  wazzupChannelType?: string | null,
): boolean => {
  const maxBytes = getCrmIntegrationVoiceMaxBytes(provider, wazzupChannelType)
  return file.size > 0 && file.size <= maxBytes
}

export const validateCrmIntegrationOutgoingVoiceFile = (
  file: File,
  provider: CrmChatProviderKey,
  wazzupChannelType?: string | null,
): string | null => {
  if (provider === 'wazzup') {
    return validateWazzupOutgoingAttachment(file, wazzupChannelType, {
      forceVoice: true,
    })
  }

  const maxBytes = getCrmIntegrationVoiceMaxBytes(provider, wazzupChannelType)
  if (file.size > maxBytes) {
    const maxMb = Math.floor(maxBytes / (1024 * 1024))
    return `Голосовое сообщение не должно превышать ${maxMb} МБ`
  }

  return null
}
